module.exports = __webpack_public_path__ + "static/media/bg.5108d5c5.jpg";